import React from 'react';
import {
  SortableContainer,
  SortableContainerProps,
  SortableElement,
  SortableElementProps,
  SortableHandle,
} from 'react-sortable-hoc';

interface ISortableHandleElement {
  children: React.ReactNode;
  className?: string;
}

interface ISortableItem extends SortableElementProps {
  children: React.ReactNode;
  className?: string;
}

interface ISortableContainer extends SortableContainerProps {
  children: React.ReactNode;
  className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Trigger: React.ComponentClass<ISortableHandleElement, any> =
  SortableHandle(
    ({
      children,
      className,
    }: {
      children: React.ReactNode;
      className?: string;
    }) => <div className={className}>{children}</div>
  );

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SortableItem: React.ComponentClass<ISortableItem, any> =
  SortableElement(
    ({
      children,
      className,
    }: {
      children: React.ReactNode;
      className?: string;
    }) => {
      return <div className={className}>{children}</div>;
    }
  );

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SortableList: React.ComponentClass<ISortableContainer, any> =
  SortableContainer(
    ({
      children,
      className,
    }: {
      children: React.ReactNode;
      className?: string;
    }) => {
      return <div className={className}>{children}</div>;
    }
  );
